import { useRoute } from "preact-iso";
import { useEffect, useState } from "preact/hooks";
import { fetchCompany } from "../../services/coupon.service";
import CouponComponent from "../Coupons/Coupon/Coupon";
import './BusinessComponent.scss';

type Company = {
    id: string;
    Name: string;
};

const Business = () => {
    const { params } = useRoute();
    const [company, setCompany] = useState<Company>(null);
    const [coupons, setCoupons] = useState<any[]>([]);

    useEffect(() => {
        if (params?.companyID) {
            fetchCompany(params.companyID).then(res => {
                if (res?.data && res.data[0]) {
                    const primaryCoupon = res.data[0];

                    setCompany({
                        id: primaryCoupon.CompanyID,
                        Name: primaryCoupon.Name
                    });

                    setCoupons(res.data);
                }
            });
        }
    }, []);
    
    return company && <div className={"business-container"}>
        <h1>{company.Name}</h1>

        <div className={"coupons-list"}>
            {coupons.map((coupon, index) => <CouponComponent coupon={coupon} key={"bus-" + index}/>)}
        </div>
    </div>
}

export default Business;